// Copyright Year
const copyrightYearSpan = document.querySelector('.year');
const copyrightYear = new Date().getFullYear();

const renderCopyrightYearSpan = function () {
  copyrightYearSpan.innerHTML = `${copyrightYear}`;
};
renderCopyrightYearSpan();
